import { LitElement, PropertyValues } from 'lit'
import { State } from 'haunted'

/**
 * This class allows us to use some of the more "React-like" state management idioms in LitElement
 * 
 * For more information on the "Haunted" library, check out: https://github.com/matthewp/haunted
 * 
 * Adapted from: https://github.com/matthewp/haunted/blob/7ac506fa77e1b5671a4e89ce864442fd429b2f26/examples/lit/app.js#LL5C3-L19C4
 */
export class LitHauntedElement extends LitElement {
  haunted: State;
  constructor() {
    super();

    this.haunted = new State(() => this.requestUpdate(), this);
  }

  update(changedProperties: PropertyValues<this>) {
    this.haunted.run(() => super.update(changedProperties));
    this.haunted.runEffects();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.haunted.teardown();
  }
}